import AssessmentFlow from './AssessmentFlow.jsx';
import BookingBanner from './BookingBanner.jsx';
import EmbedApp from './embed/EmbedApp.jsx';
import { entryFromPath, isEmbedPath } from './engine/entry.js';

// `enrolled` will come from the account (GET /api/ntq) once auth is wired. Until then
// the flow renders the PRE (lead-intake) phase, matching a not-yet-enrolled lead.
//
// The booking banner tells the client their intake call is booked. That is true for the
// booking-page redirect onto the root, but NOT for marketing traffic on /live, which has
// booked nothing — so it is hidden there. `pathname` is injectable for tests.
//
// /embed is PompaBooking's iframe (NTAI-EMB-03): no banner, and nothing at all unless the
// deploy-time config turns the embed on. `embedSettings` is injectable for tests.
export default function App({ pathname, embedSettings } = {}) {
  if (isEmbedPath(pathname)) return <EmbedApp {...(embedSettings ? { settings: embedSettings } : {})} />;
  const fromMarketing = entryFromPath(pathname) === 'live';
  return (
    <>
      {!fromMarketing && <BookingBanner />}
      <AssessmentFlow enrolled={false} />
    </>
  );
}
